import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-header border-0 py-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Sales Overview"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold fs-7" }, "Recent sales statistics")
], -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = { class: "card-body p-0 d-flex flex-column" }
const _hoisted_7 = { class: "card-p pt-5 bg-white flex-grow-1" }
const _hoisted_8 = { class: "row g-0" }
const _hoisted_9 = { class: "col mr-8" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "fs-7 text-muted fw-bold" }, "Average Sale", -1)
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "fs-4 fw-bolder" }, "$650", -1)
const _hoisted_13 = { class: "svg-icon svg-icon-5 svg-icon-success ms-1" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "col" }, [
  /*#__PURE__*/_createVNode("div", { class: "fs-7 text-muted fw-bold" }, "Commission"),
  /*#__PURE__*/_createVNode("div", { class: "fs-4 fw-bolder" }, "$233,600")
], -1)
const _hoisted_15 = { class: "row g-0 mt-8" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "col mr-8" }, [
  /*#__PURE__*/_createVNode("div", { class: "fs-7 text-muted fw-bold" }, "Annual Taxes 2019"),
  /*#__PURE__*/_createVNode("div", { class: "fs-4 fw-bolder" }, "$29,004")
], -1)
const _hoisted_17 = { class: "col" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "fs-7 text-muted fw-bold" }, "Annual Income", -1)
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "fs-4 fw-bolder" }, "$1,480,00", -1)
const _hoisted_21 = { class: "svg-icon svg-icon-5 svg-icon-danger ms-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_Dropdown1 = _resolveComponent("Dropdown1")
  const _component_apexchart = _resolveComponent("apexchart")

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card"]
  }, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("button", _hoisted_4, [
          _createVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Layout/Layout-4-blocks-2.svg" })
          ])
        ]),
        _createVNode(_component_Dropdown1)
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode("span", _hoisted_13, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-up.svg" })
              ])
            ])
          ]),
          _hoisted_14
        ]),
        _createVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode("span", _hoisted_21, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-down.svg" })
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_apexchart, {
        class: "mixed-widget-3-chart card-rounded-bottom",
        options: _ctx.chartOptions,
        series: _ctx.series,
        height: _ctx.chartHeight,
        type: "area"
      }, null, 8, ["options", "series", "height"])
    ])
  ], 2))
}